import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/views/Dashboard';
import AuthLogin from '@/views/Auth/Login';
import AuthForgotPassword from '@/views/Auth/ForgotPassword';
import AuthResetPassword from '@/views/Auth/ResetPassword';
import store from "@/store";
import authActionTypes from "@/store/modules/auth/action-types";

Vue.use(VueRouter);
const routes = [
    {
        path: '/auth/login',
        name: 'auth.login',
        component: AuthLogin,
        meta: {
            middleware: "guest",
            breadcrumb: 'Login',
        },
    },{
        path: '/auth/forgot-password',
        name: 'auth.forgot-password',
        component: AuthForgotPassword,
        meta: {
            middleware: "guest",
            breadcrumb: 'Forgot Password',
        },
    },{
        path: '/auth/reset-password/:token',
        name: 'auth.reset-password',
        component: AuthResetPassword,
        meta: {
            middleware: "guest",
            breadcrumb: 'Reset Password',
        },
    },{
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            middleware: "auth",
            breadcrumb: 'Dashboard',
        },
        redirect: {
            name: 'dashboard.home'
        },
        children: [
            {
                path: '/dashboard/home',
                name: 'dashboard.home',
                component: () => import('@/views/Home'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Home',
                },
            },{
                path: '/dashboard/faqs',
                name: 'dashboard.faqs',
                component: () => import('@/views/Dashboard/Faqs/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'FAQs',
                },
            },{
                path: '/dashboard/products',
                name: 'dashboard.products.index',
                component: () => import('@/views/Dashboard/Products/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Products',
                },
            },{
                path: '/dashboard/collections',
                name: 'dashboard.collections.index',
                component: () => import('@/views/Dashboard/Collections/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Collections',
                },
            },{
                path: '/dashboard/orders',
                name: 'dashboard.orders.index',
                component: () => import('@/views/Dashboard/Orders/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Orders',
                }
            },{
                path: '/dashboard/forms',
                name: 'dashboard.forms',
                component: () => import('@/views/Dashboard/Forms/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Forms',
                }
            },{
                path: '/dashboard/events',
                name: 'dashboard.events.index',
                component: () => import('@/views/Dashboard/Events/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Events',
                }
            },{
                path: '/dashboard/errors',
                name: 'dashboard.errors.index',
                component: () => import('@/views/Dashboard/Errors/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Errors',
                }
            },{
                path: '/dashboard/stats',
                name: 'dashboard.stats.index',
                component: () => import('@/views/Dashboard/Stats/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Stats',
                }
            },{
                path: '/dashboard/javra',
                name: 'dashboard.javra.index',
                component: () => import('@/views/Dashboard/Javra/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Javra Viewer',
                }
            },
            {
                path: '/dashboard/stats/failed-jobs',
                name: 'dashboard.stats.failed-jobs',
                component: () => import('@/views/Dashboard/Stats/FailedJobsLast24HoursIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Failed Jobs (Last 24 Hours)',
                }
            },
            {
                path: '/dashboard/stats/zigaflow-products',
                name: 'dashboard.stats.zigaflow-products',
                component: () => import('@/views/Dashboard/Stats/ZigaflowProductsIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Zigaflow Products',
                }
            },
            {
                path: '/dashboard/stats/zigaflow-products-to-sync',
                name: 'dashboard.stats.zigaflow-products-to-sync',
                component: () => import('@/views/Dashboard/Stats/ZigaflowProductsToSyncIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Zigaflow Products To Sync',
                }
            },
            {
                path: '/dashboard/stats/redirect-products-in-use',
                name: 'dashboard.stats.redirect-products-in-use',
                component: () => import('@/views/Dashboard/Stats/RedirectProductsInUseIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Redirect Products In Use',
                }
            },
            {
                path: '/dashboard/stats/redirect-products',
                name: 'dashboard.stats.redirect-products',
                component: () => import('@/views/Dashboard/Stats/RedirectProductsIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Redirect Products',
                }
            },
            {
                path: '/dashboard/stats/synced-products',
                name: 'dashboard.stats.synced-products',
                component: () => import('@/views/Dashboard/Stats/SuccessfullySyncedProductsIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Successfully Synced Products',
                }
            },
            {
                path: '/dashboard/stats/partially-synced-products',
                name: 'dashboard.stats.partially-synced-products',
                component: () => import('@/views/Dashboard/Stats/PartiallySyncedProductsIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Partially Synced Products',
                }
            },
            {
                path: '/dashboard/stats/unsynced-product-variants',
                name: 'dashboard.stats.unsynced-product-variants',
                component: () => import('@/views/Dashboard/Stats/UnsyncedProductVariantsIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Unsynced Product Variants',
                }
            },
            {
                path: '/dashboard/stats/failed-metafields',
                name: 'dashboard.stats.failed-metafields',
                component: () => import('@/views/Dashboard/Stats/FailedMetafieldUpdatesIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Failed Metafield Updates',
                }
            },
            {
                path: '/dashboard/stats/failed-images',
                name: 'dashboard.stats.failed-images',
                component: () => import('@/views/Dashboard/Stats/FailedImageUpdatesIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Failed Image Updates',
                }
            },
            {
                path: '/dashboard/stats/no-variants',
                name: 'dashboard.stats.no-variants',
                component: () => import('@/views/Dashboard/Stats/NoVariantsIndex'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Products With No Variants',
                }
            },
        ],
    },{
        path: '/',
        redirect: {
            name: 'dashboard.home'
        }
    },{
        path: '/app',
        redirect: {
            name: 'dashboard.home'
        }
    }
];

let router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach(async (to, from, next) => {
    let siteName = process.env.MIX_APP_NAME ?? 'QFConnector';
    document.title = `${to.meta.breadcrumb} – ${siteName}`

    // Persisted auth state outlives the server session, so confirm it once per page load.
    if (from === VueRouter.START_LOCATION && store.state.auth.authenticated) {
        await store.dispatch(authActionTypes.VERIFY_SESSION.PATH);
    }

    if(to.meta.middleware === "guest") {
        if(store.state.auth.authenticated) {
            next({name: "dashboard.home" });
            return;
        }
        next();
    } else {
        if(store.state.auth.authenticated) {
            next();
        } else {
            next({name: "auth.login" });
        }
    }
})

export default router;
